import { createContext, ReactElement, useContext } from "react";
import GetPresencaBatismo, { ResponsePresencaBatismo } from "../services/services";



export const PresentsBatismoContext = createContext<ResponsePresencaBatismo>(null);


export const ProviderPresenvaBatismo = ({children}: { children: ReactElement | ReactElement[] }) => {

  const hook = GetPresencaBatismo()

  return (
    <PresentsBatismoContext.Provider value={hook}>
      {children}
    </PresentsBatismoContext.Provider>
  )
}


export const UseGetMembrosParticipantes = () => {

  const context = useContext(PresentsBatismoContext);

  return context
}
